import { CustomButton } from '@Modules/core/components';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import ConsultationDatatableRowMeta from "@Modules/interfaceManagement/visaBase2/containers/tableHandlers/fees/outgoing/consultation/ConsultationDatatableRowMeta";

export type TConsultationDatatableData = {
    primaryKey: string | number,
    date: string,
    fees: string,
    name: string,
    destination: string,
    accountNumber: string,
    amount: string,
    currency: string,
    feesType: string,
    status: string,
    //
    feesTypeName: string,
    total: string,
    count: string,
    changeStatus: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  handleDetails: (row: any) => void,
  displayDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TConsultationDatatableData>()

export function getConsultationDatatableColumns({ isLoading, handleEdit, handleDetails, displayDetails }: Props) {
  
  return [
    columnHelper.accessor("date",
        {
            id: "date",
            header: "Date",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("fees",
        {
            id: "fees",
            header: "Frais",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("name",
        {
            id: "name",
            header: "Nom",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),  
    columnHelper.accessor("destination",
        {
            id: "destination",
            header: "Destination",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("accountNumber",
        {
            id: "accountNumber",
            header: "Numero compte",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("amount",
        {
            id: "amount",
            header: "Montant facture",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("currency",
        {
            id: "currency",
            header: "Devise",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("feesType",
        {
            id: "feesType",
            header: "Type frais",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "status",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    //** */
    columnHelper.accessor("feesTypeName",
        {
            id: "feesTypeName",
            header: "Type frais",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("total",
        {
            id: "total",
            header: "Total",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("count",
        {
            id: "count",
            header: "Compteur",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("changeStatus",
        {
            id: "changeStatus",
            header: "Mise a jour de statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Center>
                        {ConsultationDatatableRowMeta.changeStatus.options &&
                        ConsultationDatatableRowMeta.changeStatus.options.map((opt, i) => (
                            opt.value == props.getValue() && 
                            <span key={i}>{opt.label}</span>
                        ))}
                    </Center>
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),

    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleDetails(props.row)}                            
                        >
                            Details
                        </CustomButton>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Edit
                        </CustomButton>
                        <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
